<template>
    <li @click="onClick">
        <slot :active="isActive"/>
    </li>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import NavigationSubItem from './NavigationSubItem.vue';

@Component
export default class NavigationItem extends Vue {
    @Prop() title: string;

    @Inject({ default: () => null }) readonly register!: (item: NavigationItem) => void;

    subItems: NavigationSubItem[] = [];

    mounted() {
        this.register(this);
    }

    get isActive(): boolean {
        return this.subItems.some(si => si.active || si.subItems.some(ssi => ssi.active));
    }

    registerSubItem(item: NavigationSubItem): void {
        this.subItems.push(item);
    }

    onClick() {
        this.$emit('click', this);
    }
}
</script>
